/* Reserve the largest single-open accordion state without changing the photo. */
(() => {
  window.GrovaSections.register('grova-ingredients-layout', '.grova-pdp--ingredients', (root, scope) => {
    const content = root.querySelector('.gnp-science__content');
    if (!content) return;
    const panels = [...content.querySelectorAll('[data-science-panel]')];
    const desktop = window.matchMedia('(min-width: 991px)');
    let frame = null, disposed = false, measuredWidth = -1, measuredDesktop, forceMeasure = false;
    function measure() {
      frame = null;
      if (disposed) return;
      const width = content.clientWidth;
      if (!forceMeasure && width === measuredWidth && desktop.matches === measuredDesktop) return;
      forceMeasure = false;
      measuredWidth = width;
      measuredDesktop = desktop.matches;
      content.style.removeProperty('--ingredient-panel-height');
      if (!desktop.matches || !width) return;
      let tallest = 0;
      panels.forEach(panel => {
        const probe = panel.cloneNode(true);
        probe.hidden = false;
        probe.inert = true;
        probe.setAttribute('aria-hidden', 'true');
        probe.removeAttribute('id');
        probe.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
        Object.assign(probe.style, {
          position: 'absolute', visibility: 'hidden', pointerEvents: 'none',
          display: 'flow-root', width: `${width}px`, minHeight: '0',
          top: '0', left: '0',
        });
        const items = [...probe.querySelectorAll('details')];
        items.forEach(item => { item.open = false; });
        content.append(probe);
        tallest = Math.max(tallest, probe.getBoundingClientRect().height);
        items.forEach(item => {
          item.open = true;
          tallest = Math.max(tallest, probe.getBoundingClientRect().height);
          item.open = false;
        });
        probe.remove();
      });
      content.style.setProperty('--ingredient-panel-height', `${Math.ceil(tallest)}px`);
    }
    function schedule() {
      if (disposed || frame !== null) return;
      frame = requestAnimationFrame(measure);
    }
    if (window.ResizeObserver) {
      const observer = new ResizeObserver(() => {
        if (content.clientWidth !== measuredWidth) schedule();
      });
      observer.observe(content);
      scope.cleanup(() => observer.disconnect());
    } else {
      scope.on(window, 'resize', schedule);
    }
    scope.on(desktop, 'change', schedule);
    document.fonts?.ready.then(() => { if (!disposed) { forceMeasure = true; schedule(); } });
    schedule();
    scope.cleanup(() => {
      disposed = true;
      cancelAnimationFrame(frame);
      content.style.removeProperty('--ingredient-panel-height');
    });
  });
})();
